import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false,
    brands: [],
    brand: {},
    status: null
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    },
    [mutations.GET_ALL_BRAND_SUCCESS](state, data) {
      state.brands = data;
    },
    [mutations.GET_ALL_BRAND_FAILED](state) {
      state.brands = [];
    },
    [mutations.GET_DETAIL_BRAND_SUCCESS](state, data) {
      state.brand = data;
    },
    [mutations.GET_DETAIL_BRAND_FAILED](state) {
      state.brand = {};
    },
    [mutations.UPDATE_BRAND_SUCCESS](state, data) {
      state.brand = data;
    },
    [mutations.UPDATE_BRAND_FAILED](state) {
      state.status = 'Failed';
    }
  },
  actions: {
    getAll({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.brand
        .getAll(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          commit(mutations.GET_ALL_BRAND_SUCCESS, data.data.result);
          return data;
        })
        .catch(err => {
          console.log(err);
          commit(mutations.GET_ALL_BRAND_FAILED);
          commit(mutations.LOADED);
          return err;
        });
    },
    detail({ commit }, id) {
      commit(mutations.LOADING);
      return api.brand
        .detail(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          commit(mutations.GET_DETAIL_BRAND_SUCCESS, data.data.result);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          commit(mutations.GET_DETAIL_BRAND_FAILED);
          return err;
        });
    },
    update({ commit }, { id, params }) {
      commit(mutations.LOADING);
      return api.brand
        .update(id, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          commit(mutations.UPDATE_BRAND_SUCCESS, data.data.result);
          return data;
        })
        .catch(err => {
          console.log('error', err);
          commit(mutations.LOADED);
          commit(mutations.UPDATE_BRAND_FAILED);
          return err;
        });
    },
    create({ commit }, payload) {
      commit(mutations.LOADING);
      return api.brand
        .create(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    },
    delete({ commit }, id) {
      commit(mutations.LOADING);
      return api.brand
        .delete(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    }
  },
  getters: {
    brands: state => state.brands,
    brand: state => state.brand
  }
};
